import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { hrefFor } from '../../routers';
import { reportError } from '../../lib/reportError';
import { usePaymentError } from '../useCheckout/usePaymentError';
import { useOrderSummary } from '../useOrderSummary';
import { useAffirmSecondPayment } from './useAffirmSecondPayment';

export const useSecondPaymentWithAffirm = () => {
  const history = useHistory();
  const { orderNumber } = useParams<{ orderNumber: string }>();
  const { orderSummary } = useOrderSummary(orderNumber);
  const { setPaymentError } = usePaymentError();
  const { placeAffirmSecondPayment } = useAffirmSecondPayment();

  const handleSecondPaymentWithAffirm = useCallback(async () => {
    if (!placeAffirmSecondPayment || !orderSummary) return;
    try {
      const { data } = await placeAffirmSecondPayment();
      data &&
        history.push(
          hrefFor.OrderConfirmationPage({
            orderNumber: data.chargeOrder.data[0].attributes.orderNumber
          })
        );
    } catch (error) {
      if (error.reason !== 'canceled') {
        const errorMessage = error.networkError?.result?.errors?.[0]?.detail;
        setPaymentError(errorMessage ?? null);
        reportError(error);
      }
    }
  }, [history, orderSummary, placeAffirmSecondPayment, setPaymentError]);

  return {
    handleSecondPaymentWithAffirm
  };
};
